import { SidePanelViewModel } from "../../../viewmodels/SidePanelViewModel.js";
import { NotificationsViewModel } from "../../../../Notifications/viewmodels/NotificationsViewModel.js";
import { useNewSystemInfoCount } from "../../../../SystemInfo/shared/hooks/useNewSystemInfoCount.js";
import { OnlineIndicator } from "./OnlineIndicator.js";
import { useEffect, useState } from "react";
import { Badge, Button, ButtonGroup, Icon, Tooltip, useAtalayaContext } from "@therms/atalaya";
import { IoMdMail } from "react-icons/io";
import { jsx, jsxs } from "react/jsx-runtime";
import { useSingleton } from "mvc-kit/react";
import { MdCampaign, MdDarkMode, MdLightMode, MdNotifications } from "react-icons/md";
//#region src/modules/AppWrapper2/components/AppNav/components/StatusPill.tsx
function StatusPill() {
	const [isSystemInfoTooltipOpen, setIsSystemInfoTooltipOpen] = useState(false);
	const panelVM = useSingleton(SidePanelViewModel);
	const notificationsVM = useSingleton(NotificationsViewModel);
	const { isDarkMode, toggleDarkMode } = useAtalayaContext();
	const newSystemInfoCount = useNewSystemInfoCount();
	const hasUnreadMail = panelVM.hasUnreadMail;
	const unreadNotifications = notificationsVM.unreadCount;
	useEffect(() => {
		if (!isSystemInfoTooltipOpen && newSystemInfoCount) {
			setIsSystemInfoTooltipOpen(true);
			const timeout = setTimeout(() => setIsSystemInfoTooltipOpen(false), 3e3);
			return () => {
				clearTimeout(timeout);
			};
		}
	}, [newSystemInfoCount]);
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface gap-x-xs px-sm py-xxs inline-flex items-center rounded-full",
		children: [
			/* @__PURE__ */ jsx(OnlineIndicator, {}),
			/* @__PURE__ */ jsx("div", { className: "border-border h-base border-r" }),
			/* @__PURE__ */ jsxs(ButtonGroup, {
				size: "xs",
				subtle: true,
				children: [
					/* @__PURE__ */ jsx(Button, {
						onClick: () => panelVM.openTo("notifications"),
						size: "xs",
						children: /* @__PURE__ */ jsx(Tooltip, {
							placement: "bottom-right",
							tooltip: "Notifications",
							children: /* @__PURE__ */ jsxs("div", {
								className: "relative",
								children: [/* @__PURE__ */ jsx(Icon, {
									Icon: MdNotifications,
									color: unreadNotifications ? "strong" : void 0,
									size: "sm"
								}), unreadNotifications > 0 && /* @__PURE__ */ jsx("div", {
									className: "absolute -top-2 -right-0.5 text-right",
									children: /* @__PURE__ */ jsx(Badge, {
										size: "sm",
										subtle: false,
										max: 99,
										value: unreadNotifications,
										variant: "critical"
									})
								})]
							})
						})
					}),
					/* @__PURE__ */ jsx(Button, {
						onClick: () => panelVM.openTo("mail"),
						size: "xs",
						children: /* @__PURE__ */ jsx(Tooltip, {
							placement: "bottom-right",
							tooltip: "Mail",
							children: /* @__PURE__ */ jsxs("div", {
								className: "relative",
								children: [/* @__PURE__ */ jsx(Icon, {
									Icon: IoMdMail,
									color: hasUnreadMail ? "strong" : void 0,
									size: "sm"
								}), hasUnreadMail && /* @__PURE__ */ jsx("div", { className: "bg-info absolute top-px -right-0.5 rounded-full p-1" })]
							})
						})
					}),
					/* @__PURE__ */ jsx(Button, {
						onClick: () => panelVM.openTo("systemInfo"),
						size: "xs",
						children: /* @__PURE__ */ jsx(Tooltip, {
							placement: "bottom-right",
							tooltip: newSystemInfoCount ? "Announcements — new activity" : "Announcements",
							isOpen: isSystemInfoTooltipOpen,
							children: /* @__PURE__ */ jsxs("div", {
								className: "relative",
								children: [/* @__PURE__ */ jsx(Icon, {
									Icon: MdCampaign,
									color: newSystemInfoCount ? "strong" : void 0,
									size: "sm"
								}), !!newSystemInfoCount && /* @__PURE__ */ jsx("div", { className: "bg-main absolute top-px -right-0.5 rounded-full p-1" })]
							})
						})
					}),
					/* @__PURE__ */ jsx(Button, {
						onClick: toggleDarkMode,
						size: "xs",
						children: /* @__PURE__ */ jsx(Tooltip, {
							placement: "bottom-right",
							tooltip: "Theme",
							children: /* @__PURE__ */ jsx(Icon, {
								Icon: isDarkMode ? MdDarkMode : MdLightMode,
								size: "sm"
							})
						})
					})
				]
			})
		]
	});
}
//#endregion
export { StatusPill };

//# sourceMappingURL=StatusPill.js.map